module.exports = __webpack_public_path__ + "static/media/trash-2.55b4a141.svg";